import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";

import { Link, useNavigate } from "react-router-dom";

import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from '../../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';




//import HtlAgnOffChart from "./HtlAgnOffChart";
//import HtlPeriods from "./HtlPeriods";

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';
import { InputSwitch } from "primereact/inputswitch";
import HtlManifactCenterSubEdit from "./HtlManifactCenterSubEdit";




const GET_POST = gql`
query MyQuery(
    $dprMainCode: String
    $ownFirmCode: String
    $ownFirmSubCode: String
    ) {
        tbl_dpr_main(where: {dpr_main_code: {_eq: $dprMainCode}
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
    }) {
     
        dpr_main_code
        dpr_main_name
        dpr_dpr_type
        dpr_main_grp_code
          firm_main_code
          firm_sub_code
          active
    

  }
  tbl_dpr_sub(where: {dpr_main_code: {_eq: $dprMainCode}
    firm_main_code: { _eq: $ownFirmCode }
    firm_sub_code: { _eq: $ownFirmSubCode }
           }) {
    dpr_main_code
    dpr_sub_code   
    dpr_sub_name
    dpr_sub_type
    dpr_sub_grp_code 
    firm_main_code
    firm_sub_code
    active
   
    
    
  }
  
}
`;




const INSERT_SEA = gql`
  mutation InsertRules(
    $rulPernId: String
    $ownFirmCode: String
    $ownFirmSubCode: String
    $rulesName: String
    $lang: String  
    $ruleType: String
    $active: Boolean
   

   
    
  ) {
    insert_tbl_dpr_main(
      objects: {
        firm_main_code: $ownFirmCode,
        firm_sub_code: $ownFirmSubCode,
        dpr_main_code: $rulPernId,
        dpr_main_name: $rulesName,
        lang: $lang,
       
        dpr_dpr_type:  $ruleType,
        active: $active,
      

        
      }
    ) {
      affected_rows
    }
  }
`;


const GET_RULES_CLS = gql`
  query MyQuery( $lang: String, $defType: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
       
      }
    ) {
      lang
      type
      code
      name
    }
  }
`;

const GET_RULES_TYP = gql`
  query MyQuery( $lang: String, $defType: String, $ruleClass: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
        
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;

const UPDATE_RULES = gql`
mutation UpdateRules(
    $dprMainCode: String
    $ownFirmCode: String
    $ownFirmSubCode: String
    $rulesName: String   
    $ruleType: String
    $active: Boolean
   
    
  ) {
    update_tbl_dpr_main(
      where: {
        dpr_main_code: { _eq: $dprMainCode }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      }
      _set: {
        
        dpr_dpr_type: $ruleType
        dpr_main_name: $rulesName
        active: $active
       
      }
    ) {
      affected_rows
    }
  }
`; 

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;






const HtlManifactCenterEdit = () => {

   const {varCode, setVarCode} = useContext(ThemeContext);
   const {varCode2, setVarCode2} = useContext(ThemeContext);
   const {varCode8, setVarCode8} = useContext(ThemeContext);
   const {varCode9, setVarCode9} = useContext(ThemeContext);
   const {varCode14, setVarCode14} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);
  
  
  const { users } = useContext(UserContext);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  

  const lang = users.userLang;




 

  

     
   
  
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { dprMainCode: varCode, ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode  },
  });


  const firmData = data && data.tbl_dpr_main ? data.tbl_dpr_main[0] : null;
  const firmData2 = data && data.tbl_dpr_sub ? data.tbl_dpr_sub[0] : null;
 

  const [updateRulesPrn] = useMutation(UPDATE_RULES);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 
  const [InsertSeason] = useMutation(INSERT_SEA);

  const [displayBasic, setDisplayBasic] = useState(false);

  
  
  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
 const [firmCode, setFirmCode] = useState('');
 const [firmName, setFirmName] = useState("");
  const [firmType, setFirmType] = useState("AGN");
  const [place, setPlace] = useState("");
 // const [fmActive, setFmActive] = useState(firmData ? firmData.active : false); 
 // const [seaDesc, setSeaDesc] = useState(firmData ? firmData.firm_sub_code_k : ""); 
  const [rulPernId, setRulPernId] = useState(firmData ? firmData.dpr_main_code : ""); 
  const [firmTrg, setFirmTrg] = useState(""); 
  const [rulesName, setRulesName] = useState(firmData ? firmData.dpr_main_name : ""); 
 // const [ruleClass, setRulesClass] = useState(firmData ? firmData.build_plan_type : ""); 
  const [ruleType, setRulesType] = useState(firmData ? firmData.dpr_dpr_type : ""); 
  const [active, setActive] = useState(firmData ? firmData.active : ""); 
  const [ruleClass2, setRulesClas2] = useState(); 

  
  
 // const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
 // const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);



  const [activeTab, setActiveTab] = useState(0);
  const [activeTabS, setActiveTabS] = useState(9);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleTabChangeS = (index) => {
    setActiveTabS(index);
  };



  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
 
  const new_rule_grp_btn = messages[currentLocale].new_rule_grp_btn;
  const new_rule_btn = messages[currentLocale].new_rule_btn;
  const rule_grp_id_title = messages[currentLocale].rule_grp_id_title;
  const rule_desc_title = messages[currentLocale].rule_desc_title;
  const rule_class_title = messages[currentLocale].rule_class_title;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const update = messages[currentLocale].update;
  const rule_class_name_title = messages[currentLocale].rule_class_name_title;
  const rule_type_title = messages[currentLocale].rule_type_title;
  const rule_type_name_title = messages[currentLocale].rule_type_name_title;
  const select_rule_class_hint = messages[currentLocale].select_rule_class_hint;
  const select_rule_type_hint = messages[currentLocale].select_rule_type_hint;
  const rule_detail_title = messages[currentLocale].rule_detail_title;
  const rule_id_title = messages[currentLocale].rule_id_title;
  const detail = messages[currentLocale].detail;
  const start_date_title = messages[currentLocale].start_date_title;
  const end_date_title = messages[currentLocale].end_date_title;
 


  const { loading: defLoading, error: defError, data: defData } = useQuery(GET_RULES_CLS, {
    variables: {lang: currentLocale, defType: "CLSR"},
  });

  const { loading: defLoading2, error: defError2, data: defData2 } = useQuery(GET_RULES_TYP, {
    variables: {lang: currentLocale, defType: "WAREH"},
  });


  useEffect(() => {
    
    refetch();  
   
    console.log('Sayfa açıldı!');
    
    // componentWillUnmount
    return () => {
      console.log('Sayfa kapatılıyor...');
      refetch();  
     
    };
  }, []);

 





  useEffect(() => {
    
    if (firmTrg !== '') {
      // newId güncellendiğinde
    handleinser();  
    
    }
  }, [firmTrg, setFirmTrg]);


 

  useEffect(() => {
    if (firmData) {

        setRulesName(firmData.dpr_main_name);
        setRulPernId(firmData.dpr_main_code);
        setRulesType(firmData.dpr_dpr_type);
        setActive(firmData.active);
      
    }
  }, [firmData]);

  




  const handleUpdate = () => {
   
    
    updateRulesPrn({
      variables: {
        dprMainCode: varCode,        
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,       
        rulesName: rulesName,    
        ruleType: ruleType,
        lang: currentLocale,
        active: active,
     

        
      },
    })
      .then(() => {
        window.alert(" updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const handleUpdateIdSeq = async () => {
    const requiredFields = ['rulesName', 'ruleType' ]; // Required fiels
    const customFieldNames = {
      rulesName: "Offer Name",
     
      ruleType: "Rules Type",

    

    };
    const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
  
    if (emptyFields.length === 0) {
      try {
        const { data } = await updateIdSeq2({
          variables: {
            type: 'MFIRM', 
          },
        });
        const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
        
        setFirmTrg(String(updatedIdSeq));
        setRulPernId(String(updatedIdSeq));
        setVarCode(String(updatedIdSeq));
     //   setIdSeqTrg(updatedIdSeq);
        
        console.log(rulPernId);
        // setVarCode(updatedIdSeq.toString());  
      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    } else {
      
      const emptyFieldsMessage = `Boş Alanları Doldurun: ${emptyFields.join(', ')}`;
     // console.log(emptyFieldsMessage);
      window.alert(emptyFieldsMessage);
    }
  };

  const getEmptyFields = (requiredFields, customFieldNames) => {
    const emptyFields = [];
  
    // Boş olan alanları bul
    for (const field of requiredFields) {
      if (!eval(field)) {
        emptyFields.push(customFieldNames[field]);
      }
    }
  
    return emptyFields;
  };

  const handleinser = () => {
    InsertSeason({
      variables: {


        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
        rulPernId: rulPernId,
        rulesName: rulesName,
        lang: currentLocale,
     //   ruleClass: ruleClass,
        ruleType: ruleType,  
        active: active,   
       
   //     startDate: new Date(startDate).toLocaleDateString(),
   //     endDate: new Date(endDate).toLocaleDateString(),
   //     fmActive: fmActive,
    
    
           
      },
    })
      .then(() => {
        window.alert("Rules insert successfully!");
      })
      .catch((error) => {
        console.error("Error insert Rules:", error);
      });
  };


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

      
  const onClick = () => {
    setVarCode9(ruleType)
    setDisplayBasic(true);
    
  };

  const onClick2 = () => {
    setVarCode8('0');     
    setVarCode9(ruleType)
    setDisplayBasic(true);
    
  };
  
  const onHide = () => {
    setDisplayBasic(false);
    refetch();
  };


  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-sm"
      : "text-gray-500 font-bold text-sm";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };


  const rulesClasstems = defData && defData.tbl_gnl_def
  ? defData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const rulesTypeItems = defData2 && defData2.tbl_gnl_def
  ? defData2.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];






  return (

    <div className="container -mt-4 mx-auto sm:p-4 ">
      
  
   


         <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Building Detail"}
            </span>
          }
          className="ml-5 flex"
        >
      <div>

    
    <div className=" p-2 ">
         <div className="pt-1"> 
           <Fieldset>
             <p className="my-0  ">


      <div className="flex gap-4">
          <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{rule_grp_id_title}</label>
    <InputText className="w-full text-base" 
    id="username" value={rulPernId}
    onChange={(e) => setRulPernId(e.target.value)}
    readOnly
    />
  </div>


  <div className="w-2/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{rule_type_title}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={ruleType} 
    onChange={(e) => setRulesType(e.target.value)} autoComplete="off"/>
    
  </div>

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {rule_type_name_title}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
        style={{ width: '244px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={ruleType}
         options={rulesTypeItems}
         onChange={(e) => setRulesType(e.value)}
         placeholder={select_rule_type_hint}
         />
       </div>
   
      

  <div className="w-4/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{rule_desc_title}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={rulesName} 
    onChange={(e) => setRulesName(e.target.value)} autoComplete="off"/>
    
  </div>

  <div className="mr-2 w-1/5">
    <label htmlFor="firmType" className="block font-medium text-gray-700"> 
      {"Aktif"}
    </label>
    <InputSwitch checked={active} onChange={(e) => setActive(e.value)} />
  </div> 

  </div>

      <div className="flex mt-5 gap-4 ">
      <div className="w-2/4">
     
  </div>
  <div className="w-2/4">
    <Button
      label={new_rule_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={onClick2}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={update}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleUpdate}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={new_rule_grp_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
      onClick={handleUpdateIdSeq}
    />
  </div>
</div>

<div>
<Dialog visible={displayBasic} style={{ width: '55vw' }}header={"Build Plan"} onHide={onHide}>
  <p>
   {<HtlManifactCenterSubEdit/>}
  </p>
</Dialog>
</div>
</p>
   </Fieldset>
       </div>
 
       </div>          
  
  </div>


 <p> <DataTable
         value={data.tbl_dpr_sub }
         scrollable 
         scrollHeight="250px" loading={loading}
         stickyHeader
         stickyTopAt=".layout-topbar"
        

        >
           <Column field="dpr_main_code"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Build Id"}</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>
        

          <Column field="dpr_sub_code"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Build Plan Id"}</span>}
           style={{ textAlign: 'left', width: '9rem' }}
          >
          </Column>
          <Column field="dpr_sub_type"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Plan Type"}</span>}
           style={{ textAlign: 'left', width: '15rem' }}
          >
          </Column>

          <Column field="dpr_sub_name"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{rule_desc_title}</span>}
           style={{ textAlign: 'left', width: '15rem' }}
          >
          </Column>


          <Column field="opt_1"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{rule_desc_title}</span>}
           style={{ textAlign: 'left', width: '15rem' }}
          >
          </Column>

          <Column
            field="active"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">{statusrec}</span>}
            style={{ textAlign: 'center', width: '6rem' }}
            className="font-bold text-sm" 
          />


          <Column
          header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
                setVarCode8(rowData.dpr_sub_code);  
                setVarCode(rowData.dpr_main_code);                          
                onClick();
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable></p>    

              </TabPanel>
              <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Rule Related"}
            </span>
          }
          className="ml-5 flex"
        >

         
    

              </TabPanel>
            
          </TabView>   
     
    </div>




    
    
    
 
 
);
};

export default HtlManifactCenterEdit;
